import type { StateCreator } from 'zustand'
import type { Auth0Role } from '~/config/auth'
import type { AppStore } from '../useStore'

export interface AuthUser {
  sub: string
  email: string
  name: string
  picture?: string
  role: Auth0Role
  customer: string
}

export interface AuthSlice {
  user: AuthUser | null
  setUser: (u: AuthUser) => void
  clear: () => void
}

export const createAuthSlice: StateCreator<AppStore, [], [], { auth: AuthSlice }> = (set) => ({
  auth: {
    user: null,
    setUser: (user) => set((s) => ({ auth: { ...s.auth, user } })),
    clear: () => set((s) => ({ auth: { ...s.auth, user: null } })),
  },
})
